<ngx-spinner class="custom-spinner"
bdColor="rgba(255,255,255,1)"
  size="medium"
  color="#fff"
  type="ball-atom"
  [fullScreen]="true"
>
<span class="loader">
  <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
</span>
</ngx-spinner>

<div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
    <!--begin::Toolbar container-->
    <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
        <!--begin::Page title-->
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <!--begin::Title-->
            <div class="d-flex align-items-center">
                <h1 class="page-heading"><svg width="44" height="43" viewBox="0 0 44 43" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <g filter="url(#filter0_d_645_3009)">
                            <path
                                d="M18.7669 18.2479L20.2009 16.8132C20.5761 16.438 20.7824 15.94 20.7824 15.4093C20.7824 14.8786 20.5761 14.3806 20.2009 14.0054C19.4512 13.2557 18.1437 13.2551 17.3934 14.0054L15.8281 15.2901C16.265 15.8571 16.7442 16.4096 17.2706 16.936C17.7528 17.4183 18.2569 17.8461 18.7669 18.2479Z"
                                fill="#265D91" />
                            <path
                                d="M19.7183 4.39722C17.488 3.81388 15.6008 4.15154 14.4034 5.34969C13.206 6.54723 12.8672 8.43522 13.451 10.6645C13.7905 11.9619 14.4252 13.2889 15.2917 14.5567L16.7831 13.3343C17.2962 12.8181 18.0229 12.5168 18.7956 12.5168C19.5682 12.5168 20.2949 12.8181 20.8407 13.364C21.3871 13.9104 21.6878 14.6371 21.6878 15.4093C21.6878 16.1814 21.3865 16.9088 20.8407 17.4546L19.4975 18.798C21.5565 20.2327 23.7293 21.0133 25.5747 21.0133C26.8871 21.0133 28.0343 20.6224 28.8554 19.8019C31.2599 17.3971 29.9741 12.1991 25.9898 8.21435C24.0893 6.31365 21.862 4.95817 19.7183 4.39662V4.39722Z"
                                fill="#265D91" />
                            <path
                                d="M14.9818 26.3747C14.9818 26.2543 14.934 26.1387 14.8487 26.054L8.15301 19.3577C7.97573 19.1804 7.68832 19.1804 7.51104 19.3577L4.72109 22.1479C3.75964 23.1095 3.75964 24.6743 4.72109 25.6359L8.57111 29.4863C9.53256 30.4478 11.0973 30.4478 12.0587 29.4863L14.8487 26.6961C14.934 26.6107 14.9818 26.4946 14.9818 26.3747Z"
                                fill="#265D91" />
                            <path
                                d="M39.8525 0.422165C39.8349 0.171643 39.6105 -0.0195759 39.3678 0.00160343L37.2997 0.147438C37.0498 0.164987 36.861 0.382227 36.8792 0.632144C36.8967 0.882665 37.114 1.06904 37.3639 1.05271L38.3586 0.982511L34.773 4.39905L33.034 2.99274C32.8579 2.84993 32.6044 2.859 32.4392 3.01331L28.8809 6.32637C28.6975 6.49701 28.6872 6.78445 28.8579 6.9678C29.0291 7.15176 29.3165 7.16084 29.4992 6.9908L32.769 3.94641L34.5116 5.35514C34.6889 5.49856 34.9448 5.48888 35.11 5.33094L39.0254 1.59974L39.0925 2.55463C39.1095 2.80515 39.3303 2.99395 39.5772 2.97519C39.8271 2.95764 40.0159 2.7404 39.9977 2.49048L39.8525 0.422165Z"
                                fill="#265D91" />
                            <path
                                d="M15.8107 27.017L13.0625 29.7654L16.8321 33.5354C17.5969 34.3057 18.8614 34.2549 19.5803 33.4482C19.9354 33.093 20.1315 32.6198 20.1315 32.1176C20.1315 31.6153 19.9354 31.1421 19.5803 30.7869L15.8107 27.017Z"
                                fill="#265D91" />
                            <path
                                d="M12.574 10.8937C12.45 10.4199 12.3762 9.96306 12.3266 9.51648L8.125 18.0548C8.13347 18.0621 16.1445 26.0479 16.1512 26.0812L24.6771 21.8852C22.0276 21.5942 19.0827 20.0335 16.628 17.578C14.6155 15.5647 13.1755 13.1908 12.574 10.8937Z"
                                fill="#265D91" />
                        </g>
                        <defs>
                            <filter id="filter0_d_645_3009" x="0" y="0" width="43.998" height="42.0844"
                                filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                <feColorMatrix in="SourceAlpha" type="matrix"
                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                <feOffset dy="4" />
                                <feGaussianBlur stdDeviation="2" />
                                <feComposite in2="hardAlpha" operator="out" />
                                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_645_3009" />
                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_645_3009"
                                    result="shape" />
                            </filter>
                        </defs>
                    </svg>


                    Appel d’offre
                </h1>
                <!--begin::Menu-->

            </div>
            <!--end::Title-->
            <!--begin::Breadcrumb-->
            <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted">
                    <a routerLink="/accueil" class="text-muted ">Accueil</a>
                  </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item">
                    <span class="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted cursor-pointer" routerLink="/offres-appel/liste">Appel d'offre</li>
                <!--end::Item-->
                <li class="breadcrumb-item">
                    <span class="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <li class="breadcrumb-item text-muted"> Archive</li>
            </ul>
            <!--end::Breadcrumb-->
        </div>
        <!--end::Page title-->
        <!--begin::Actions-->

        <!--end::Actions-->
    </div>
    <!--end::Toolbar container-->
</div>
<div id="kt_app_content" class="app-content flex-column-fluid mb-15">
    <!--begin::Content container-->
    <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Card-->
        <div class="card">
            <!--begin::Card header-->
            <form [formGroup]="searchForm">
                <div class="card-body">
                    <div class="title mb-10">
                        <h4>Recherche</h4>
                    </div>
                    <div class="row mb-5">
                        <div class="col-lg-6">
                            <div class="input-group search-libre">
                                <span class="input-group-text">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                        fill="none">
                                        <path
                                            d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                                            fill="#7E7C7C" />
                                    </svg>
                                </span>

                                <input type="text" data-kt-customer-table-filter="search" class="form-control ps-5"
                                    placeholder="Rechercher" formControlName="search" (keyup.enter)="searchappeloffre(1); startSearching = true"/>
                                <div class="tooltip-container tooltip-info">
                                    <div class="tooltip-trigger"><i class="fa-solid fa-circle-info"
                                            style="font-size: 20px;"></i></div>
                                    <div class="tooltip-content">
                                        <div class="content">
                                            <h4>Opérateur AND :</h4>
                                            <p>Utilisez l'opérateur AND pour spécifier que les résultats doivent inclure
                                                plusieurs termes.
                                            </p>
                                            <p>Exemple : software AND engineer renverra des profils qui mentionnent à la
                                                fois "software" et "engineer".
                                            </p>
                                            <h4>Opérateur OR :</h4>
                                            <p>Utilisez l'opérateur OR pour spécifier que les résultats peuvent inclure
                                                l'un des termes.
                                            </p>
                                            <p>Exemple : sales OR marketing renverra des profils qui mentionnent soit
                                                "sales" soit "marketing".
                                            </p>
                                            <h4>Opérateur NOT :</h4>
                                            <p>Utilisez l'opérateur NOT pour exclure des termes spécifiques des
                                                résultats.
                                            </p>
                                            <p>Exemple : developer NOT manager renverra des profils qui mentionnent
                                                "developer" mais pas "manager".
                                            </p>
                                            <h4>Guillemets pour une expression exacte :</h4>
                                            <p>Utilisez des guillemets pour rechercher une expression exacte.
                                            </p>
                                            <p>Exemple : "product manager" renverra des profils qui mentionnent
                                                exactement "product manager".
                                            </p>
                                            <h4>Parenthèses pour grouper des opérations :</h4>
                                            <p>Utilisez des parenthèses pour définir l'ordre d'évaluation des
                                                opérations.
                                            </p>
                                            <p>Exemple : (sales OR marketing) AND manager renverra des profils qui
                                                mentionnent "sales" ou "marketing" et "manager".
                                            </p>
                                            <h4>Recherche standard :</h4>
                                            <p>Si aucun opérateur n'est spécifié dans la recherche, le texte sera
                                                interprété comme s'il était entre guillemets.
                                            </p>
                                            <p>Exemple : La recherche product manager sera traitée comme "product
                                                manager", suivant la règle 4.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="text-danger mt-2"
                                    *ngIf="searchForm.get('search')?.hasError('pattern') && searchForm.get('search')?.touched && isSimpleWord(searchForm.get('search')?.value)">
                                    Le modèle de recherche est invalide.
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="tools">

                        <div class="row mb-3">




                            <div class="col-lg-3">
                                <input type="text" formControlName="ID_jobRequest" id="ID_jobOffer"
                                    class="form-control form-control-solid mb-3" placeholder="ID">

                            </div>
                            <div class="col-lg-3">
                                <input type="text" formControlName="name" id="Poste"
                                    class="form-control form-control-solid mb-3" placeholder="Poste">

                            </div>
                            <div class="col-lg-3"><input type="text" formControlName="client_final_name" id="client"
                                    class="form-control form-control-solid mb-3" placeholder="Nom entreprise">

                            </div>
                            <div class="col-lg-3">

                            
                                <div class="combined-input mb-3">
                              
                                    <input type="number" formControlName="years_of_experience"
                                        oninput="validity.valid||(value='0');" min="0" class="form-control mb-3"
                                        placeholder="Année d’éxperience" aria-label="Amount (to the nearest dollar)"
                                        class="nb1" />
                                    <input type="number" formControlName="experience_range"
                                        oninput="validity.valid||(value='0');" min="0" class="nb2" value=""
                                        placeholder="marge_année d’éxperience" id="marge_année d’éxperience">

                                    <div class="plusetmois">
                                        <i class="fa-solid fa-plus-minus"></i>
                                    </div>


                                </div>
                            </div>
                           

                        </div>
                        <div class="row mb-3" *ngIf="seeMore">
                            <div class="col-lg-3">
                                <ng-select [items]="contrat" [bindValue]="'id'" [multiple]="true" [bindLabel]="'name'"  [notFoundText]="'Aucun élément trouvé'"
                                    id="contrat" formControlName="contract_type" class=" mb-3" 
                                    placeholder="Type de contrat">
                                </ng-select>
                            </div>
                            <div class="col-lg-3">
                                <div class="combined-input mb-3">
                                    <input type="number" formControlName="desired_salary"
                                        oninput="validity.valid||(value='0');" min="0" class="nb1" placeholder="Salaire"
                                        id="Salaire">
                                    <div class="euro">
                                        <svg width="11" height="11" viewBox="0 0 11 11" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                                                fill="#4B4B4B" />
                                        </svg>
                                    </div>
                                    <input type="number" formControlName="desired_salary_range"
                                        oninput="validity.valid||(value='0');" min="0" class="nb2" value="" (change)="alreadyConverted=false" (input)="onSalaryRangeInput($event)"
                                        id="marge_tjm">
                                    <div class="icon">
                                        <svg width="20" height="15" viewBox="0 0 19 11" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M5.37 10L1.352 5.548V10H0.0780001V0.242H1.352V4.764L5.384 0.242H6.994L2.57 5.128L7.036 10H5.37Z"
                                                fill="#4B4B4B" />
                                            <path
                                                d="M13.889 8.739C14.435 8.739 14.9117 8.62633 15.319 8.401C15.735 8.167 16.06 7.82467 16.294 7.374H18.075C17.737 8.24067 17.1953 8.908 16.45 9.376C15.7047 9.844 14.851 10.078 13.889 10.078C12.875 10.078 11.9737 9.805 11.185 9.259C10.3963 8.70433 9.846 7.96767 9.534 7.049H8.338V6.035H9.3C9.28267 5.79233 9.274 5.60167 9.274 5.463C9.274 5.32433 9.28267 5.13367 9.3 4.891H8.338V3.877H9.534C9.846 2.95833 10.3963 2.226 11.185 1.68C11.9737 1.12533 12.875 0.847999 13.889 0.847999C14.8423 0.847999 15.6917 1.08633 16.437 1.563C17.191 2.031 17.737 2.69833 18.075 3.565H16.294C16.06 3.11433 15.735 2.77633 15.319 2.551C14.9117 2.317 14.435 2.2 13.889 2.2C13.2563 2.2 12.6973 2.34733 12.212 2.642C11.7353 2.93667 11.3713 3.34833 11.12 3.877H13.889V4.891H10.834C10.808 5.073 10.795 5.26367 10.795 5.463C10.795 5.66233 10.808 5.853 10.834 6.035H13.889V7.049H11.12C11.3713 7.58633 11.7353 8.00233 12.212 8.297C12.6973 8.59167 13.2563 8.739 13.889 8.739Z"
                                                fill="#4B4B4B" />
                                        </svg>
                                    </div>
                                    <div class="plusetmois">
                                        <i class="fa-solid fa-plus-minus"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3">
                                <div class="combined-input mb-3">
                                    <input type="number" formControlName="tjm" oninput="validity.valid||(value='0');"
                                        min="0" class="nb1" placeholder="TJM" id="tjm">
                                    <div class="euro">
                                        <svg width="11" height="11" viewBox="0 0 11 11" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                                                fill="#4B4B4B" />
                                        </svg>
                                    </div>
                                    <input type="number" formControlName="tjm_range"
                                        oninput="validity.valid||(value='0');" min="0" class="nb2" value=""
                                        id="marge_tjm">
                                    <div class="icon">
                                        <svg width="11" height="11" viewBox="0 0 11 11" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                                                fill="#4B4B4B" />
                                        </svg>
                                    </div>
                                    <div class="plusetmois">
                                        <i class="fa-solid fa-plus-minus"></i>
                                    </div>
                                </div>

                            </div>
                            <div class="col-lg-3">

                                <ng-select [items]="poste" [bindValue]="'id'" [multiple]="true" [bindLabel]="'name'"  [notFoundText]="'Aucun élément trouvé'"
                                    id="Poste"  formControlName="post_type"
                                    placeholder="Type de poste">
                                </ng-select>
                            </div>
                        </div>
                        <div class="row mb-3" *ngIf="seeMore">

                            <div class="col-lg-3">
                                <ng-select [items]="skillsList"  bindLabel="name_FR" class=" mb-3"  [notFoundText]="'Aucun élément trouvé'"
                                    formControlName="skillsAnd" bindValue="name_FR" [multiple]="true"
                                    placeholder="Compétences (et)" [notFoundText]="'Aucun élément trouvé'" autoComplete>
                                </ng-select>
                            </div>
                            <div class="col-lg-3">
                                <ng-select [items]="skillsList"  bindLabel="name_FR" class=" mb-3"  [notFoundText]="'Aucun élément trouvé'"
                                    formControlName="skillsOr" bindValue="name_FR" [multiple]="true"
                                    [placeholder]="'Compétences (ou)'" [notFoundText]="'Aucun élément trouvé'" autoComplete>
                                </ng-select>
                            </div>
                            <div class="col-lg-3">
                                <ng-select [items]="disponibilite" [multiple]="true"  class=" mb-3"  [notFoundText]="'Aucun élément trouvé'"
                                    formControlName="availability" bindLabel="name" bindValue="id"
                                    [placeholder]="'Disponibilité'" autoComplete>
                                </ng-select>
                            </div>
                            <div class="col-lg-3" *ngIf="connectedUser!='esn-non-abonnee'">
                                <ng-select (change)="onCountryChange('add');" [multiple]="true" [items]="paysList" class=" mb-3"  [notFoundText]="'Aucun élément trouvé'"
                                    bindLabel="name" formControlName="country" bindValue="name" [placeholder]="'Pays'"
                                    autoComplete>
                                </ng-select>
                            </div>

                        </div>

                        <div class="row mb-3" *ngIf="seeMore">

                            <div class="col-lg-3">
                                <ng-select  [items]="stateList" [ngClass]="{'disable-select':!stateList?.length}" [attr.disabled]="!stateList?.length ? true : null" bindLabel="name" class=" mb-3" (change)="onMobilityChange('add')" [notFoundText]="'Aucun élément trouvé'"
                                    formControlName="city" [multiple]="true" bindValue="name" [placeholder]="'Ville'"
                                    autoComplete [notFoundText]="'Aucun élément trouvé'">
                                </ng-select>

                            </div>
                     
                            <div class="col-lg-3 calenderDate">
                                <div class="position-relative d-flex align-items-center  mb-3">
                                    <!--begin::Datepicker-->
                                    <p-calendar [style]="{'border': 'none','margin-top': '-6px'}" dateFormat="dd/mm/yy"  placeholder="Date de début de publication" inputId="yearpicker" 
                                    formControlName="start_date" class="form-control"
                                   ></p-calendar>
                                    <!--end::Datepicker-->
                                </div>
                            </div>
                            <div class="col-lg-3 calenderDate">
                                <div class="position-relative d-flex align-items-center  mb-3">
                                    <!--begin::Datepicker-->
                                    <p-calendar [style]="{'border': 'none','margin-top': '-6px'}" dateFormat="dd/mm/yy"  placeholder="Date de fin de publication" inputId="yearpicker" 
                          formControlName="end_date" class="form-control"
                         ></p-calendar>
                                    <!--end::Datepicker-->
                                </div>
                            </div>
                            <div class="col-lg-3">
                                <ng-select  [items]="profile" bindLabel="name"
                                class=" mb-3" bindValue="id" [placeholder]="'Profil à l\'étranger'"  [notFoundText]="'Aucun élément trouvé'"
                                formControlName="profile_abroad" autoComplete>
                            </ng-select>
                            </div>
                        </div>
                        <div class="row" *ngIf="seeMore">
                            <div class="col-lg-3"><input type="text" formControlName="client_final_name" id="client"
                                class="form-control form-control-solid mb-3" placeholder="Passeport talent">
                        </div>
                        <div class="col-lg-3">

                            <ng-select [items]="status" [bindValue]="'id'" [bindLabel]="'name'" id="status"  [notFoundText]="'Aucun élément trouvé'"
                                 formControlName="state" placeholder="Statut">
                            </ng-select>
                        </div>

                        </div>
                        <div class="row">
                            <div class="col-lg-3"></div>
                            <div class="col-lg-3"></div>
                            <div class="col-lg-3"></div>
                            <div class="col-lg-3">
                                <div class="see-more mb-5">
                                    <a class="" (click)="seeMore=!seeMore">Voir {{!seeMore?'plus':'moins'}} de critères
                                        de recherche</a>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-3">

                            </div>
                            <div class="col-lg-3">

                            </div>
                            <div class="col-lg-3">

                            </div>
                            <div class="mb-3 search-btn d-flex justify-content-end">
                                <div class="align-items-center recherche">
                                    <button type="button" class="me-5" (click)="searchappeloffre(1); startSearching = true">
                                        <svg width="15" height="15" viewBox="0 0 20 20" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                                                fill="white" />
                                        </svg>
                                        Rechercher</button>
                                </div>
                                <div class="resett-btn">
                                    <div class="reset-icon cursor-pointer" data-bs-toggle="tooltip"
                                        data-bs-placement="top" title="Réinitialiser">
                                        <a (click)="reset()"> <img src="/assets/media/icons/reset.png" alt=""
                                                width="30px"></a>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>
            </form>
        </div>

    </div>
    <!--end::Content container-->
</div>

<div id="kt_app_content" class="app-content flex-column-fluid mb-4">
    <!--begin::Content container-->
    <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Card-->
        <div class="card pt-10">
            <!--begin::Card header-->
            <div class="d-flex flex-wrap header-grid align-items-center mb-5">
                <div class="section_title">
                    <h1 class="section-heading my-5">Listes des appels d'offres archivés</h1>
                </div>
                <!--begin::Tab nav-->
                <ul class="nav nav-pills me-5">
                    <li class="nav-item m-0">
                        <a class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary  me-3"
                            data-bs-toggle="tab" href="#kt_project_targets_card_pane">
                            <i class="ki-duotone ki-element-plus fs-1">
                                <span class="path1"></span>
                                <span class="path2"></span>
                                <span class="path3"></span>
                                <span class="path4"></span>
                                <span class="path5"></span>
                            </i>
                        </a>
                    </li>
                    <li class="nav-item m-0">
                        <a class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary active"
                            data-bs-toggle="tab" href="#kt_project_targets_table_pane">
                            <i class="ki-duotone ki-row-horizontal fs-2">
                                <span class="path1"></span>
                                <span class="path2"></span>
                            </i>
                        </a>
                    </li>
                </ul>
                <!--end::Tab nav-->
            </div>
            <!--end::Card header-->
            <!--begin::Card body-->
            <div class="card-body pt-10">
                <div class="tab-content for-web">
                    <!--begin::Tab pane-->
                    <div id="kt_project_targets_card_pane" class="tab-pane fade ">
                        <!--begin::Row-->
                        <div class="row g-6 g-xl-9 justify-content-center">
                            <!--begin::Col-->
                            <div class="col-md-6 col-xxl-4" *ngFor="let appel of listappeloffre">
                                <!--begin::Card-->
                                <div class="card pt-5 p-5">
                                    <div class="tools">

                                        <div class="dropdown">
                                            <button
                                                class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                                type="button" id="dropdownMenuButton" data-bs-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="false">
                                                <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                        transform="matrix(1 0 0 -1 0 4.89478)" fill="#265D91" />
                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                        transform="matrix(1 0 0 -1 6.85254 4.89478)" fill="#265D91" />
                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                        transform="matrix(1 0 0 -1 13.7061 4.89478)" fill="#265D91" />
                                                </svg>
                                            </button>
                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                              
                                                <a class="dropdown-item dropdown"
                                                    [routerLink]="['/offres-appel/details-offer', appel.id, true]">voir
                                                    détail</a>
                                                <a class="dropdown-item dropdown"
                                                    (click)="restaurerappeloffre(appel.id)">Restaurer</a>
                                            </div>
                                        </div>
                                    </div>
                                    <!--begin::Card body-->
                                    <div class="card-body d-flex flex-center flex-column">
                                        <!--begin::Avatar-->
                                        <div class="symbol symbol-65px symbol-circle mb-5">
                                         
                                            <img *ngIf="appel.client_final?.logo && appel.client_final?.logo!='avatar.png' &&  appel.client_final?.logo!=='undefined'"
                                                src="{{url+'/Company/file/gallery_company/'+ appel.client_final?.logo}}"
                                                alt="logo" width="50px">
                                            <img *ngIf="!appel.client_final?.logo ||  appel.client_final.logo==='undefined'"
                                                src="/assets/media/icons/avatar.jpg" alt="" width="50px">
                                            <img *ngIf="appel.client_final.logo && (appel.client_final.logo=='avatar.jpg' || appel.client_final.logo=='avatar.png')"
                                                class="table-img" src="/assets/media/icons/avatar.jpg" alt=""
                                                width="75px">
                                        </div>
                                        <span> {{appel?.client_final ?.type=='1'?'Entrepeise':appel.client_final?.type=='2'?'ESN':appel.client_final?.type=='3'?'Client Final':'Cabinet de Recrutement'}}</span>
                                      


                                        <!--end::Avatar-->
                                        <!--begin::Name-->
                                        <a [routerLink]="['/offres-appel/details-offer', appel.id, true]"
                                            class="fs-4 text-gray-800 text-hover-primary fw-bold mb-5">{{appel.name ?
                                            appel.name :'---'}} </a>
                                      
                                        <div class="content-card">
                                          


                                            <div class="info">
                                                <div class="py-3 m-2">
                                                    <div class="badge-annee"> <span>Salaire :</span> 
                                                        <span *ngIf="appel.salary!=='0'" >{{appel.salary ?
                                                        appel.salary + ' &euro;' :'---'}} </span>
                                                        
                                                        <span *ngIf="appel.salary==='0'">---</span>
                                                    </div>
                                                </div>

                                                <div class="py-3 m-2">
                                                    <div class="badge-annee"> <span>Tjm :</span>
                                                        <span *ngIf="appel.tjm!=='0'" > {{appel.tjm ? appel.tjm
                                                        + ' &euro;' : '---'}}</span>
                                                       <span *ngIf="appel.tjm==='0'">---</span>  
                                                    
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="py-3 px-4 mx-2">
                                                <div class="badge-annee"> <span>ANS.EXP :</span>
                                                    <span *ngIf="appel.years_of_experience!=='0 ans'" > 
                                                    {{appel.years_of_experience ? appel.years_of_experience :'---'}}</span>
                                                    <span *ngIf="appel.years_of_experience==='0 ans'">---</span>
                                                </div>
                                            </div>
                                
                                        </div>


                                        <!--end::Info-->
                                    </div>
                                    <div class="foot p-5">

                                        <div class="plus">
                                            <a [routerLink]="['/offres-appel/details-offer', appel.id, true]">Voir
                                                plus</a>
                                        </div>
                                    </div>
                                    <!--end::Card body-->
                                </div>
                                <!--end::Card-->
                            </div>

                            <div class="alert alert-warning text-center mt-5" role="alert"
                            *ngIf="listappeloffre && !listappeloffre.length">
                                <img src="/assets/media/errors/no-data.png" alt="" class="mb-5">
                                <span class="empty-list">
                                    La liste est vide
                                </span>
                            </div>
                            <div class="pagination" *ngIf="listappeloffre && listappeloffre.length">
                                <app-pagination [data]="listappeloffre" [lengthData]="totalItems"
                                    (setPages)="getItems($event)" [currentPageList]="currentPage"> </app-pagination>
                            </div>
                        </div>
                        <!--end::Row-->
                    </div>
                    <!--end::Tab pane-->
                    <!--begin::Tab pane-->
                    <div id="kt_project_targets_table_pane" class="tab-pane fade show active">
                        <div class="content">
                            <div class="card-body pt-3">
                                <!--begin::Table-->
                                <div class="table-responsive" id="kt_customers_table">
                                    <table class="table align-middle style-table  gy-5" >
                                        <thead>
                                            <tr class="text-start text-gray-400 fw-bold text-uppercase gs-0">
                                                <th *ngIf="filterColumns('id')"class="min-w-125px"><span>ID<i class="fa-solid fa-sort cursor-pointer"
                                                    (click)="sortData('ID_jobRequest')"></i></span></th>
                                                <th *ngIf="filterColumns('logo')" class="min-w-125px"><span>logo entreprise</span></th>
                                                <th *ngIf="filterColumns('societe')"  class="min-w-125px th-fixed"><span>Nom entreprise<i class="fa-solid fa-sort cursor-pointer "
                                                    (click)="sortData('client_name')"></i></span></th>
                                                <th  *ngIf="filterColumns('type')" class="min-w-125px"><span>Type</span></th>
                                            

                                                <th *ngIf="filterColumns('poste')" class="min-w-125px th-fixed2"><span>POSTE
                                                    <i class="fa-solid fa-sort cursor-pointer" (click)="sortData('name')"></i></span>
                                                </th>
                                                <th  *ngIf="filterColumns('dateOfPublication')"class="min-w-175px"><span>Date de publication
                                                    <i class="fa-solid fa-sort cursor-pointer" (click)="sortData('start_date')"></i></span>
                                                </th>
                                                <th *ngIf="filterColumns('experience')" experienceclass="min-w-150px"><span>Années d’expérience
                                                    <i class="fa-solid fa-sort cursor-pointer"
                                                        (click)="sortData('years_of_experience')"></i></span>
                                                </th>
                                                <th *ngIf="filterColumns('Suggestions')" class="min-w-125px"><span>Suggestions</span>

                                                </th>
                                                <th *ngIf="filterColumns('typeofContrat')" class="min-w-125px"><span>Type de contrat
                                                    <i class="fa-solid fa-sort cursor-pointer" (click)="sortData('contract_type')"></i></span>
                                                </th>
                                                <th  *ngIf="filterColumns('Salaire')" class="min-w-125px"><span>Salaire
                                                    <i class="fa-solid fa-sort cursor-pointer" (click)="sortData('salary')"></i></span>
                                                </th>
                                                <th *ngIf="filterColumns('TJM')" class="min-w-125px"><span>TJM
                                                    <i class="fa-solid fa-sort cursor-pointer" (click)="sortData('tjm')"></i></span>
                                                </th>

                                                <th  *ngIf="filterColumns('typeOfPost')"class="min-w-125px"><span>Type de poste
                                                    <i class="fa-solid fa-sort cursor-pointer" (click)="sortData('post_type')"></i></span>
                                                </th>
                                                <th *ngIf="filterColumns('skills')" class="min-w-125px"><span>Compétences</span>

                                                </th>

                                                <th *ngIf="filterColumns('pays')" class="min-w-125px"><span>Pays <i (click)="sortData('country')"
                                                    class="fa-solid fa-sort cursor-pointer"></i></span></th>

                                                <th *ngIf="filterColumns('ville')" class="min-w-125px"><span>Ville
                                                    <i class="fa-solid fa-sort cursor-pointer" (click)="sortData('city')"></i></span>
                                                </th>





                                                <th *ngIf="filterColumns('state')" class="min-w-125px"><span>Statut</span>
                                                </th>
                                                <th class="min-w-90px"><span>Actions</span></th>
                                                <th class="min-w-70px">
                                                    <div class="dropdown">
                                                        <button class="dropdown-toggle" type="button"
                                                            id="dropdownMenuButton" data-bs-toggle="dropdown"
                                                            aria-haspopup="true" aria-expanded="false">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="28"
                                                                height="28" viewBox="0 0 28 28" fill="none">
                                                                <g filter="url(#filter0_d_588_1699)">
                                                                    <rect x="4" width="20" height="20" rx="4"
                                                                        fill="#63C3E8" fill-opacity="0.12"
                                                                        shape-rendering="crispEdges" />
                                                                </g>
                                                                <path
                                                                    d="M17.5 10.6H14.6V13.5C14.6 13.8314 14.3314 14.1 14 14.1C13.6686 14.1 13.4 13.8314 13.4 13.5V10.6H10.5C10.1686 10.6 9.9 10.3314 9.9 10C9.9 9.66863 10.1686 9.4 10.5 9.4H13.4V6.5C13.4 6.16863 13.6686 5.9 14 5.9C14.3314 5.9 14.6 6.16863 14.6 6.5V9.4H17.5C17.8314 9.4 18.1 9.66863 18.1 10C18.1 10.3314 17.8314 10.6 17.5 10.6Z"
                                                                    fill="#265D91" stroke="#265D91"
                                                                    stroke-width="0.2" />
                                                                <defs>
                                                                    <filter id="filter0_d_588_1699" x="0" y="0"
                                                                        width="28" height="28"
                                                                        filterUnits="userSpaceOnUse"
                                                                        color-interpolation-filters="sRGB">
                                                                        <feFlood flood-opacity="0"
                                                                            result="BackgroundImageFix" />
                                                                        <feColorMatrix in="SourceAlpha"
                                                                            type="matrix"
                                                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                                            result="hardAlpha" />
                                                                        <feOffset dy="4" />
                                                                        <feGaussianBlur stdDeviation="2" />
                                                                        <feComposite in2="hardAlpha"
                                                                            operator="out" />
                                                                        <feColorMatrix type="matrix"
                                                                            values="0 0 0 0 0.14902 0 0 0 0 0.364706 0 0 0 0 0.568627 0 0 0 0.13 0" />
                                                                        <feBlend mode="normal"
                                                                            in2="BackgroundImageFix"
                                                                            result="effect1_dropShadow_588_1699" />
                                                                        <feBlend mode="normal"
                                                                            in="SourceGraphic"
                                                                            in2="effect1_dropShadow_588_1699"
                                                                            result="shape" />
                                                                    </filter>
                                                                </defs>
                                                            </svg>
                                                        </button>
                                                        <div class="dropdown-table">
                                                            <div class="dropdown-menu"
                                                                aria-labelledby="dropdownMenuButton">
                                                                <div *ngFor="let column of getCheckboxStateEntries()">
                                                                    <div class="form-check form-check-custom form-check-solid mb-3">
                                                                        <input class="form-check-input" type="checkbox" 
                                                                               [checked]="column[1].isChecked" 
                                                                               (change)="updateCheckboxState(column[0])" />
                                                                        <label class="form-check-label" [for]="'checkbox' + column[0].toUpperCase()">{{ column[1].displayName }}</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody class="fw-semibold text-gray-600">
                                            <tr *ngFor="let appel of listappeloffre">
                                                <td  *ngIf="filterColumns('id')">
                                                    <a routerLink="/offres-appel/details-offer/{{appel.id}}"><span class="first-td">
                                                        {{appel.ID_jobRequest?appel.ID_jobRequest:'---'}}</span></a>
                                                  
                                                </td>
                                                <td *ngIf="filterColumns('logo')">
                                                    <img *ngIf="appel.client_final?.logo && appel.client_final?.logo!='avatar.png' &&  appel.client_final?.logo!=='undefined'"
                                                        src="{{url+'/Company/file/gallery_company/'+ appel.client_final?.logo}}"
                                                        alt="logo" width="50px" height="50px" class="circular-image">
                                                    <img class="circular-image"
                                                        *ngIf="!appel.client_final?.logo ||  appel.client_final.logo==='undefined'"
                                                        src="/assets/media/icons/avatar.jpg" alt="" width="50px">
                                                    <img class="circular-image"
                                                        *ngIf="appel.client_final.logo && (appel.client_final.logo=='avatar.jpg' || appel.client_final.logo=='avatar.png')"
                                                        class="table-img circular-image"
                                                        src="/assets/media/icons/avatar.jpg" alt="" width="75px">


                                                </td>
                                                <td *ngIf="filterColumns('societe')"  class="td-fixed">
                                                    <span> {{appel.client_name}}</span>
                                                </td>
                                                <td  *ngIf="filterColumns('type')">
                                                    <span class="wrapping"
                                                        [ngClass]="appel?.client_final
                                                    ?.type=='1'?'type-data':appel.client_final?.type=='2'?
                                                    'esn-type':appel.client_final?.type=='3'?'client-type':'centre-type'">
                                                        {{appel?.client_final?.type=='1'?'Entrepeise':appel.client_final?.type=='2'?
                                                        'ESN':appel.client_final?.type=='3'?'Client Final':'Cabinet de Recrutement'}}</span>
                                                </td>
                                                <td  *ngIf="filterColumns('poste')" class="td-fixed2">
                                                    <a class="first-td"
                                                        [routerLink]="['/offres-appel/details-offer', appel.id, true]">{{appel.name}}</a>
                                                </td>
                                                <td *ngIf="filterColumns('dateOfPublication')">
                                                    <span>{{!appel.start_date ? '---' : appel.start_date.split('
                                                        ')[0].split('-').reverse().join('/') }}</span>
                                                </td>
                                                <td *ngIf="filterColumns('experience')">
                                                    <span *ngIf="appel.years_of_experience!=='0 ans'" >{{appel.years_of_experience ? appel.years_of_experience
                                                        :'---'}} ans</span>
                                                      <span *ngIf="appel.years_of_experience==='0 ans'">---</span>   
                                                </td>
                                                <td *ngIf="filterColumns('experience')">
                                                <a routerLink="/offres-appel/suggestions/{{appel.id}}" class="cursor-pointer suggestions" >voir suggestions</a>
                                                </td>
                                                <td *ngIf="filterColumns('typeofContrat')">
                                                    <ng-container *ngFor="let contract of appel.contract_type">
                                                        <div class="list-type" class="aligment-center">
                                                            <span  *ngIf="contract==1">Alternance</span>
                                                            <span  *ngIf="contract==2">Autres type de contrat</span>
                                                            <span  *ngIf="contract==3">CDD</span>
                                                            <span *ngIf="contract==4">CDI</span>
                                                            <span *ngIf="contract==5">Freelance</span>
                                                            <span *ngIf="contract==6">Portage salarial</span>
                                                            <span *ngIf="contract==7">Stage</span>
                                                       
                                                        </div>
                                                    </ng-container>
                                                    <span *ngIf="appel.contract_type===null">---</span>
                                                </td>
                                                <td *ngIf="filterColumns('Salaire')">
                                                    <span *ngIf="appel.salary!=='0'">{{appel.salary ? appel.salary :'---'}} &euro;</span>
                                                    <span *ngIf="appel.salary==='0'">---</span>
                                                </td>
                                                <td *ngIf="filterColumns('TJM')">
                                                    <span *ngIf="appel.tjm!=='0'">{{appel.tjm ? appel.tjm :'---'}} &euro;</span>
                                                    <span *ngIf="appel.tjm==='0'">---</span>

                                                </td>
                                                <td *ngIf="filterColumns('typeOfPost')">
                                                    <!-- <span class="badge badge-type teletravail-badge"> jhjjj</span> -->

                                                    <span *ngIf="appel.post_type==1" class="badge remote">A distance</span>
                                                    <span *ngIf="appel.post_type==2" class="badge onsite">Hybride</span>
                                                    <span *ngIf="appel.post_type==3" class="badge hybrid">Sur site</span>
                                                    <span *ngIf="!appel.post_type">---</span>

                                            
             
                                                </td>

                                                <td *ngIf="filterColumns('skills')">
                                                    <ng-container *ngIf="appel.skills_job">
                                               
                                                    <div class="skills">
                                                        <ng-container class="badge java"
                                                            *ngFor="let skill of appel.skills_job.slice(0,3)">
                                                            <span>
                                                                <div class="badge java">
                                                                    {{skill?.sub_category?.name_FR?skill?.sub_category?.name_FR:'---'}}
                                                                </div>
                                                            </span>
                                                            <!-- icon if the length of skills is greater then 2 -->

                                                        </ng-container>
                                                        <span
                                                            *ngIf="appel.skills_job?.length&&appel.skills_job?.length>2"><svg
                                                                width="8" height="8" viewBox="0 0 8 8" fill="none"
                                                                xmlns="http://www.w3.org/2000/svg">
                                                                <path
                                                                    d="M7.34144 4.86849H4.51344V7.76649H3.02944V4.86849H0.201438V3.52449H3.02944V0.626487H4.51344V3.52449H7.34144V4.86849Z"
                                                                    fill="#ACA7A7" />
                                                            </svg>
                                                        </span>
                                                    </div>
                                              
                                                <td class="cle" *ngIf="!appel.skills_job?.length">
                                                    <span class="key-word">
                                                        <div><svg width="6" height="6" viewBox="0 0 6 6" fill="none">
                                                            </svg>---</div>
                                                    </span>
                                                </td>
                                                </ng-container>
                                                <span *ngIf="!appel.skills_job">---</span>
                                                </td>




                                                <td *ngIf="filterColumns('pays')">
                                                    <span>{{appel.country ? appel.country :'---'}} </span>
                                                </td>

                                                <td *ngIf="filterColumns('ville')"> <span>{{appel.city ? appel.city :'---'}} </span>
                                                </td>






                                                <td *ngIf="filterColumns('state')">
                                                    <span *ngIf="appel.state==0" class="badge actif"> <i
                                                            class="fa-solid fa-circle"></i>
                                                        Actif
                                                    </span>
                                                    <span *ngIf="appel.state==1" class="badge desactif"> <i
                                                            class="fa-solid fa-circle"></i>
                                                        Non Actif
                                                    </span>
                                                </td>
                                                <td class="actions">
                                                    <div class="tools">
                                                        <div class="dropdown">
                                                            <button
                                                                class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                                                type="button" id="dropdownMenuButton"
                                                                data-bs-toggle="dropdown" aria-haspopup="true"
                                                                aria-expanded="false">
                                                                <svg width="19" height="5" viewBox="0 0 19 5"
                                                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                        transform="matrix(1 0 0 -1 0 4.89478)"
                                                                        fill="#265D91" />
                                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                        transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                                                        fill="#265D91" />
                                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                                        transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                                                        fill="#265D91" />
                                                                </svg>
                                                            </button>
                                                            <div class="dropdown-menu"
                                                                aria-labelledby="dropdownMenuButton">
                                                                <a class="dropdown-item"
                                                                    [routerLink]="['/offres-appel/details-offer', appel.id, true]">Voir
                                                                    détail</a>
                                                                <!-- <a class="dropdown-item"  >Voir offre</a> -->

                                                                <a class="dropdown-item"
                                                                    (click)="restaurerappeloffre(appel.id)">Restaurer</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                </div>

                                <!--end::Table-->
                                <div class="pagination" *ngIf="listappeloffre && listappeloffre.length">
                                    <app-pagination [data]="listappeloffre" [lengthData]="totalItems"
                                        (setPages)="getItems($event)" [currentPageList]="currentPage"> </app-pagination>
                                </div>
                                <div class="alert alert-warning text-center mt-5" role="alert"
                                *ngIf="listappeloffre && !listappeloffre.length">
                                    <img src="/assets/media/errors/no-data.png" alt="" class="mb-5">
                                    <span class="empty-list">
                                        La liste est vide
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--end::Tab pane-->
                </div>

                <div class="tab-content for-mobile">
                    <!--begin::Tab pane-->
                    <div id="kt_project_targets_card_pane" class="tab-pane fade show active">
                        <!--begin::Row-->
                        <div class="row g-6 g-xl-9 justify-content-center">
                            <!--begin::Col-->
                            <div class="col-md-6 col-xxl-4" *ngFor="let appel of listappeloffre">
                                <!--begin::Card-->
                                <div class="card pt-5 p-5">
                                    <div class="tools">

                                        <div class="dropdown">
                                            <button
                                                class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                                type="button" id="dropdownMenuButton" data-bs-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="false">
                                                <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                        transform="matrix(1 0 0 -1 0 4.89478)" fill="#265D91" />
                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                        transform="matrix(1 0 0 -1 6.85254 4.89478)" fill="#265D91" />
                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                        transform="matrix(1 0 0 -1 13.7061 4.89478)" fill="#265D91" />
                                                </svg>
                                            </button>
                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                <!-- <a class="dropdown-item dropdown" >Voir offre</a> -->
                                                <a class="dropdown-item dropdown"
                                                    [routerLink]="['/offres-appel/details-offer', appel.id, true]">voir
                                                    détail</a>
                                                <a class="dropdown-item dropdown"
                                                    (click)="restaurerappeloffre(appel.id)">Restaurer</a>
                                            </div>
                                        </div>
                                    </div>
                                    <!--begin::Card body-->
                                    <div class="card-body d-flex flex-center flex-column">
                                        <!--begin::Avatar-->
                                        <div class="symbol symbol-65px symbol-circle mb-5">
                                            <!-- <img src="assets/media//avatars/300-2.jpg" alt="image" /> -->
                                            <img *ngIf="appel.client_final?.logo && appel.client_final?.logo!='avatar.png' &&  appel.client_final?.logo!=='undefined'"
                                                src="{{url+'/Company/file/gallery_company/'+ appel.client_final?.logo}}"
                                                alt="logo" width="50px">
                                            <img *ngIf="!appel.client_final?.logo ||  appel.client_final.logo==='undefined'"
                                                src="/assets/media/icons/avatar.jpg" alt="" width="50px">
                                            <img *ngIf="appel.client_final.logo && (appel.client_final.logo=='avatar.jpg' || appel.client_final.logo=='avatar.png')"
                                                class="table-img" src="/assets/media/icons/avatar.jpg" alt=""
                                                width="75px">
                                        </div>
                                        <span> {{appel?.client_final
                                            ?.type=='1'?'Entrepeise':appel.client_final?.type=='2'?'ESN':appel.client_final?.type=='3'?'Client
                                            Final':'Cabinet de Recrutement'}}</span>
                                        <!-- <ng-container  *ngIf="jobofferDetails?.client_final?.type=='3'" > Client Final</ng-container>  -->


                                        <!--end::Avatar-->
                                        <!--begin::Name-->
                                        <a [routerLink]="['/offres-appel/details-offer', appel.id, true]"
                                            class="fs-4 text-gray-800 text-hover-primary fw-bold mb-5">{{appel.name ?
                                            appel.name :'---'}} </a>
                                        <!--end::Name-->
                                        <!--begin::Position-->
                                        <!--end::Position-->
                                        <!--begin::Info-->
                                        <div class="content-card">
                                            <!--                                            
                                            <div  class="py-3 px-4 mx-2">
                                                <span  *ngIf="appel.post_type==1" class="badge-annee">A distance</span>
                                                <span *ngIf="appel.post_type==2" class="badge-annee">Hybride</span>
                                                <span  *ngIf="appel.post_type==3" class="badge-annee">Sur site</span>
    
                                              
                                            </div> -->
                                            <!--begin::Stats-->


                                            <div class="info">
                                                <div class="py-3 m-2">
                                                    <div class="badge-annee"> <span>Salaire :</span> {{appel.salary ?
                                                        appel.salary + ' &euro;' :'---'}} </div>
                                                </div>

                                                <div class="py-3 m-2">
                                                    <div class="badge-annee"> <span>Tjm :</span> {{appel.tjm ? appel.tjm
                                                        + ' &euro;' : '---'}} </div>
                                                </div>
                                            </div>
                                            <div class="py-3 px-4 mx-2">
                                                <div class="badge-annee"> <span>ANS.EXP :</span>
                                                    {{appel.years_of_experience ? appel.years_of_experience :'---'}}
                                                </div>
                                            </div>
                                            <!--end::Stats-->
                                            <!--begin::Stats-->
                                            <!-- <div class="py-3 px-4 mx-2">
                                                <div class="badge-annee"> <span>VILLE :</span> {{appel.city ?appel.city : '---'}}</div>
                                            </div> -->
                                            <!-- <div class="types py-3 px-4 mx-2">
                                                <ng-container *ngFor="let contract of appel.contract_type">
                                                        <div class="badge-annee"*ngIf="contract==1">Alternance</div>&nbsp;
                                                        <div class="badge-annee" *ngIf="contract==2">Autres type de contrat</div>&nbsp;
                                                        <div class="badge-annee" *ngIf="contract==3">CDD</div>&nbsp;
                                                        <div class="badge-annee" *ngIf="contract==4">CDI</div>
                                                        <div class="badge-annee" *ngIf="contract==5">Freelance</div>
                                                        <div class="badge-annee" *ngIf="contract==6">Portage salarial</div>
                                                        <div class="badge-annee" *ngIf="contract==7">Stage</div>
                                                
                                                        </ng-container>
                                                       
                                            </div> -->
                                            <!--end::Stats-->
                                            <!--begin::Stats-->


                                            <!--end::Stats-->
                                        </div>


                                        <!--end::Info-->
                                    </div>
                                    <div class="foot p-5">

                                        <div class="plus">
                                            <a [routerLink]="['/offres-appel/details-offer', appel.id, true]">Voir
                                                plus</a>
                                        </div>
                                    </div>
                                    <!--end::Card body-->
                                </div>
                                <!--end::Card-->
                            </div>

                            <div class="alert alert-warning text-center mt-5" role="alert"
                *ngIf="listappeloffre && !listappeloffre.length">
                    <img src="/assets/media/errors/no-data.png" alt="" class="mb-5">
                    <span class="empty-list">
                        La liste est vide
                    </span>
                </div>
                <div class="pagination" *ngIf="listappeloffre && listappeloffre.length">
                                    <app-pagination [data]="listappeloffre" [lengthData]="totalItems"
                                        (setPages)="getItems($event)" [currentPageList]="currentPage"> </app-pagination>
                                </div>
                        </div>
                        <!--end::Row-->
                    </div>
                    <!--end::Tab pane-->
                    <!--begin::Tab pane-->
                  
                    <!--end::Tab pane-->
                </div>
                <!--end::Table-->
               
            </div>
            <!--end::Card body-->

        </div>
    </div>
    <!--end::Content container-->
</div>